<image-editor></image-editor>

<div class="overlay" #overlay></div>


<div class="loader">
    <ng-content></ng-content>
</div>